import Averon101 from '../Averon 9/Averon 9 (1).webp'
import Averon102 from './Averon 10 (2).webp'
import Averon103 from './Averon 10 (3).webp'
import Averon104 from './Averon 10 (4).webp'
import Averon105 from './Averon 10 (5).webp'
import Averon106 from './Averon 10 (6).webp'
import Averon107 from './Averon 10 (7).webp'
import Averon108 from './Averon 10 (8).webp'
import Averon109 from './Averon 10 (9).webp'
import Averon1010 from './Averon 10 (10).webp'
import Averon1011 from './Averon 10 (11).webp'



const Averon10images =[
Averon101,Averon102,Averon103,Averon104,Averon105,Averon106,Averon107,Averon108,Averon109,Averon1010,Averon1011
]

export default Averon10images;